import { PIAGlm3Config } from '@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs';
import { MakeConfig } from '../../helpers/configHelper';

export const QuoteToolConfigs = MakeConfig({
  config: PIAGlm3Config,
  brokerFriendlyName: 'PIA'
});
